import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../models/api-response.model';
import { NotificacionDominioDto } from '../models/notificacion-dominio.model';
import { AuthService } from './auth.service';
import { BaseApiService } from './api-base.service';
import { ConfigService } from './config.service';
import { ConfigClientService } from './configClient.service';
import { SINERGIAL_ROUTES } from '../constants/api-sinergial-routes';

const DEFAULT_PARAMS = {
  pageNumber: -1,
  Orden: 2,
  SentidoOrden: 'asc',
} as const;

@Injectable({ providedIn: 'root' })
export class NotificacionDominioService extends BaseApiService<
  ApiResponse<NotificacionDominioDto[]>
> {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    authService: AuthService,
    configClientService: ConfigClientService,
  ) {
    super(http, configService, configClientService, authService);
  }

  getDominios(
    extra?: Record<string, string | number | boolean>,
  ): Observable<ApiResponse<NotificacionDominioDto[]>> {
    return this.get<ApiResponse<NotificacionDominioDto[]>>(SINERGIAL_ROUTES.NOTIFICACION_DOMINIO.PATH_BASE, {
      params: { ...DEFAULT_PARAMS, ...extra },
    });
  }
}
